import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import {Icones} from './FontConfig'


export default function UpdateButton (props){
    return <Button 
                {...props}
                icon= {Icones.Editar}
                />
}